// extracted by mini-css-extract-plugin
module.exports = {"wrapper__main":"q_D","numeral__wrapperMain":"q_6","numeral__item":"q_7","backdrop":"q_8"};